import { render, staticRenderFns } from "./SingleKayaBillReport.vue?vue&type=template&id=32c005c5&"
import script from "./SingleKayaBillReport.vue?vue&type=script&lang=js&"
export * from "./SingleKayaBillReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports